import React, { useState, useEffect } from 'react';
import { Widget, GridView, SimpleView, Table, Form, Row, FormInput, Col, Button, FormResetButton, CompositeView } from '@digital/ui';
import { getAllLogSendMail, LogSendMail } from '@app/api/log';
import FormEnviarEmail from './formEnviarEmail';
import { ColumnProps } from 'antd/lib/table';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { compareText, compareDates } from '@app/helpers/comparators';
import { Icon } from 'antd';

const LogSendMail = () => {
  const [getAll, setAll] = useState<LogSendMail[]>();

  useEffect(() => {
    getAllLogMail();
  }, []);

  const getAllLogMail = async () => {
    const result = await getAllLogSendMail();
    if (result) {
      setAll(result);
    }
  };

  const column: ColumnProps<LogSendMail>[] = [
    {
      title: 'Assunto',
      dataIndex: 'subject',
      width: 400,
      sorter: (a, b) => compareText(a.subject, b.subject),
      render: (text) => (
        <div title={text} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 380 }}>
          {text}
        </div>
      ),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Assunto"
              name="subject"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.subject !== undefined &&
        record.subject
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Data do Envio',
      dataIndex: 'dataDoEnvio',
      width: 160,
      sorter: (a, b) => compareDates(a.dataDoEnvio, b.dataDoEnvio),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data do Envio"
              name="dataInicio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataDoEnvio !== undefined &&
        record.dataDoEnvio
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      width: 220,
      sorter: (a, b) => compareText(a.email, b.email),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar E-mail"
              name="subject"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.email !== undefined &&
        record.email
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      render: (text) => (
        <div title={text} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 200 }}>
          {text}
        </div>
      ),
    },
    {
      title: 'Cc-Email',
      dataIndex: 'ccEmail',
      width: 220,
      render: (text, record) => (
        <div title={record.ccEmail} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 200 }}>
          {record.ccEmail}
        </div>
      ),
    },
    {
      title: 'Erro',
      width: 200,
      ellipsis: true,
      dataIndex: 'descricaoErro',
    },
    {
      title: 'Opções',
      width: '3%',
      align: 'center',
      render: (text, record, index) => {
        {
          return (
            <FormEnviarEmail
              htmlTexto={record.message}
              mostrarModal={false}
              email={record.email}
              cc={record.ccEmail}
              ccEmailTela={record.ccEmailTela}
              emailLogId={record.id}
              onAfterSend={getAllLogMail}
            />
          );
        }
      },
    },
  ];

  useEffect(() => {}, []);

  return (
    <CompositeView>
      <SimpleView>
        <GridView noform>
          <Widget title="Relatório de Envio de E-mail com falhas">
            <Table columns={column} dataSource={getAll} rowKey={'id'} pagination={{pageSize: 100}} scroll={{ x: true }} />
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default LogSendMail;
